import { useEffect, useState } from "react";
import Sidebar from "../components/Sidebar";
import Header from "../components/Header";
import { Outlet, useLocation } from "react-router-dom";

export default function MainLayout({ headerText }) {
  const location = useLocation();
  const [pageKey, setPageKey] = useState(location.key);

  useEffect(() => {
    setPageKey(location.key);
  }, [location.key]);

  return (
    <div className="min-h-screen bg-[#EDF0F2] font-sans text-[#323334] flex">
      {/* Sidebar fijo */}
      <Sidebar />

      {/* Contenido principal */}
      <div key={pageKey} className="flex-1 ml-0 lg:ml-[302px] p-4 sm:p-6 mt-10 lg:mt-0 animate-fade-in">
        <div className="flex items-center justify-between px-0 sm:px-6">
          <h2 className="text-xl sm:text-2xl font-semibold">{headerText}</h2>
          <Header />
        </div>

        <Outlet />
      </div>
    </div>
  );
}